import { useMutation } from "@tanstack/react-query";
import React from "react";
import { patchOrder } from "src/api/booksOrder";
import { useDialogStore } from "src/store/useDialogStore";
import useSnackbar from "src/store/useSnackbar";
import { useCheckoutForm } from "./useCheckoutForm";
/** 토스 결제 최소 금액 */ const MIN_FINAL_PRICE = 500;
/**
 * 결제 CTA를 눌렀을 때 일어나는 일
 *
 * 주문 정보 갱신(patchOrder), 폼 제출, 최소 금액 검증, 결제수단별 분기가
 * CheckoutView 곳곳과 JSX 안에 흩어져 있어 한곳으로 모았다.
 *
 * usePayment는 여기서 호출하지 않는다. 그쪽은 토스에서 돌아왔을 때 완료 페이지로
 * 보내는 처리까지 담당해 "제출"보다 넓은 관심사이므로, 호출부에서 조합해 넘긴다.
 */ export const useCheckoutSubmit = (param)=>{
    let { id , isBilling , shouldUseForm , finalPrice , paymentCategory , ready , paymentHandle , requestBilling  } = param;
    const { addSnackbar  } = useSnackbar();
    const { open  } = useDialogStore();
    const updateOrderMutation = useMutation(patchOrder);
    const { handleSubmit , onValidFormSubmit , onInvalidFormSubmit  } = useCheckoutForm(async (data)=>{
        //response가 success가 true인데 업데이트 안되는 이유 확인 필요
        const response = await updateOrderMutation.mutateAsync({
            id,
            buyerName: data.buyerName,
            buyerPhone: data.buyerPhone
        });
        if (response.success) {
            paymentHandle(paymentCategory);
        } else {
            addSnackbar({
                message: "다시 시도해주세요.",
                variant: "error"
            });
        }
    });
    /** 잔여 결제 금액이 토스 최소 금액에 못 미치면 조정을 안내하고 막는다 */ const checkMinFinalPrice = ()=>{
        if (finalPrice === 0) return true;
        if (finalPrice < MIN_FINAL_PRICE) {
            open({
                id: "min-pay-price",
                type: "confirm",
                props: {
                    title: "잔여 결제 금액을 500원 이상으로 설정해주세요.",
                    description: "캐시\xb7포인트\xb7쿠폰 적용 후 남은 금액이 500원 이상이 되도록 다시 조정해주세요.",
                    confirmText: "금액 조정하기"
                }
            });
            return false;
        }
        return true;
    };
    const submitPayment = (e)=>{
        // 빌링은 미동의 시 스낵바를 띄워야 하므로 버튼을 막지 않고 클릭 시점에 검증한다
        if (isBilling) {
            requestBilling();
            return;
        }
        if (!checkMinFinalPrice()) return;
        if (shouldUseForm) {
            handleSubmit(onValidFormSubmit, onInvalidFormSubmit)(e);
        } else {
            paymentHandle(paymentCategory);
        }
    };
    // 빌링은 버튼을 막지 않는다. 미동의·중복요청 모두 클릭 시점에 requestBilling이 처리한다.
    const isPaymentEnabled = isBilling ? true : ready && finalPrice > 0 || finalPrice === 0;
    return {
        submitPayment,
        isPaymentEnabled
    };
};
